import { useTranslation } from "react-i18next";
import Field from "../../ui/forms/Field";
import { FORM_COMPACT_CONTROL_CLASS, FORM_HELP_TEXT_CLASS } from "../../ui/styles/formStyles";

interface BudgetFieldsProps {
  /** As typed; an empty field means no limit. */
  value: { readonly calls: string; readonly tokens: string };
  onChange: (value: { calls: string; tokens: string }) => void;
}

/** A server key's calls and tokens per calendar month (PR-5). */
export default function BudgetFields({ value, onChange }: BudgetFieldsProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-1">
      <div className="flex flex-wrap gap-3">
        <Field label={t("serverKeys.budgetCalls")} layout="inline">
          {(control) => (
            <input {...control} type="number" min={1} className={`${FORM_COMPACT_CONTROL_CLASS} max-w-32`} value={value.calls}
              onChange={(event) => { onChange({ ...value, calls: event.target.value }); }} />
          )}
        </Field>
        <Field label={t("serverKeys.budgetTokens")} layout="inline">
          {(control) => (
            <input {...control} type="number" min={1} className={`${FORM_COMPACT_CONTROL_CLASS} max-w-40`} value={value.tokens}
              onChange={(event) => { onChange({ ...value, tokens: event.target.value }); }} />
          )}
        </Field>
      </div>
      <p className={FORM_HELP_TEXT_CLASS}>{t("serverKeys.budgetHelp")}</p>
    </div>
  );
}
